import getElementDetailsByGlobalId from "./get_element_details_by_global_id";
import getPlannedElementsByGlobalId from "./get_planned_elements_by_global_id";
import PlannedBuildingElement from "../../../models/domain/planned_building_element";

import type { ReduxStore } from "../../reducers/root_reducer";

/** One element of the current floor, with any details loaded for it (eg: on selection). */
const getPlannedElementWithDetails = (state: ReduxStore, globalId: string): PlannedBuildingElement => {
  const element = getPlannedElementsByGlobalId(state, {})[globalId];
  return element && PlannedBuildingElement.withDetails(element, getElementDetailsByGlobalId(state, {})[globalId]);
};

export default getPlannedElementWithDetails;
